import { Component, OnInit, inject } from '@angular/core';
import {
  CardData,
  CardListComponent,
} from '../cards/card-list/card-list.component';
import { Module, ModulesService } from '../../services/modules/modules.service';
import { FileService } from '../../services/file/file-service';
import { TenantsService } from '../../services/tenants/tenants.service';
import { AppService } from '../../services/app/app.service';

@Component({
  selector: 'app-home',
  imports: [CardListComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  private moduleService = inject(ModulesService);
  private fileService = inject(FileService);
  private tenantService = inject(TenantsService);
  private appService = inject(AppService);

  public tenant = this.tenantService.activeTenant;

  public columns = 3;
  public cards: CardData[] = [];

  async ngOnInit(): Promise<void> {
    this.appService.headerTitle.set(this.appService.appName);
    await this.loadModules();
  }

  private async loadModules(): Promise<void> {
    const modules: Module[] = await this.moduleService.getModules(
      this.tenantService.activeTenant,
    );

    modules.forEach((module: Module) => {
      const card: CardData = {
        title: module.title,
        titleColor: 'black',
        subtitle: module.content.subtitle,
        size: module.width,
        sort: module.sort,
        link: `${this.tenantService.activeTenant}/${module.type}`,
      };

      if (module.image && module.type !== 'biography') {
        this.fileService.getAsset(module.image).then((image) => {
          card.imgSrc = URL.createObjectURL(image!);
        });
      }

      if (module.type === 'biography' && module.image) {
        this.fileService.getAsset(module.image).then((image) => {
          card.circleImgSrc = URL.createObjectURL(image!);
          card.titlePosition = 'below';
          card.circleSizePx = '100px';
        });
      }

      this.cards.push(card);
    });
  }
}
